import React, { useState } from "react";
import { Link } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db, storage } from "../firebase";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { motion } from "framer-motion";

const AdminDashboard = () => {
  // notice
  const [notice, setNotice] = useState("");
  const [noticeTitle, setNoticeTitle] = useState("");
  const [noticeDate, setNoticeDate] = useState("");
  const [openNotice, setOpenNotice] = useState("");
  const [closeNotice, setCloseNotice] = useState("");

  // book pdf upload
  const [uploadFile, setUploadFile] = useState("");
  const [bookName, setBookName] = useState("");
  const [className, setClassName] = useState("");

  // upload toppers
  const [uploadFileToppers, setUploadFileToppers] = useState("");
  const [classStream, setClassstream] = useState("");
  const [studentName, setStudentName] = useState("");
  const [studentPercentage, setStudentPercentage] = useState("");

  // upload photos
  const [uploadFileGallery, setUploadFileGallery] = useState("");
  const [category, setCategory] = useState("");

  // notice
  const addNotice = async () => {
    await addDoc(collection(db, "noticeAll"), {
      notice,
      noticeTitle,
      noticeDate,
    }).then(() => {
      window.location.reload(false);
    });
  };

  // book pdf upload
  const handleUpload = async () => {
    if (uploadFile) {
      const storageRef = ref(
        storage,
        "update/" + uploadFile.fileName + "/" + Date.now()
      );
      const uploadTask = uploadBytesResumable(storageRef, uploadFile);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // eslint-disable-next-line default-case
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          // eslint-disable-next-line default-case
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;

            case "storage/unknown":
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            await addDoc(collection(db, "syllabusUpload"), {
              pictureUrl: downloadURL,
              bookName,
              className,
            }).then(() => {
              window.location.reload(true);
            });
          });
        }
      );
    } else {
      alert("Please fill all the details");
    }
  };

  // upload toppers
  const handleToppersUpload = async () => {
    if (uploadFileToppers) {
      const storageRef = ref(
        storage,
        "update/" + uploadFileToppers.fileName + "/" + Date.now()
      );
      const uploadTask = uploadBytesResumable(storageRef, uploadFileToppers);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // eslint-disable-next-line default-case
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          // eslint-disable-next-line default-case
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;

            case "storage/unknown":
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            await addDoc(collection(db, "toperStudents"), {
              pictureUrl: downloadURL,
              studentName,
              studentPercentage,
              classStream,
            }).then(() => {
              window.location.reload(false);
            });
          });
        }
      );
    } else {
      alert("Please fill all the details");
    }
  };

  // upload photos
  const handleGalleryUpload = async () => {
    if (uploadFileGallery) {
      const storageRef = ref(
        storage,
        "update/" + uploadFileGallery.fileName + "/" + Date.now()
      );
      const uploadTask = uploadBytesResumable(storageRef, uploadFileGallery);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // eslint-disable-next-line default-case
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          // eslint-disable-next-line default-case
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;

            case "storage/unknown":
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            await addDoc(collection(db, "galleryUpload"), {
              pictureUrl: downloadURL,
              category,
              date: serverTimestamp(),
            }).then(() => {
              window.location.reload(true);
            });
          });
        }
      );
    } else {
      alert("Please fill all the details");
    }
  };

  return (
    <>
      <div className="grid lg:grid-cols-2 lg:grid-rows-2 sm:grid-cols-1 gap-10 p-10">
        <motion.div
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: -100 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          viewport={{ once: true }}
          className="h-80 w-full flex justify-center items-center bg-gray-50 shadow-lg rounded-lg"
        >
          <ul>
            <li className="relative group mr-6 text-white">
              <div className=" mb-5 mt-5">
                <Link to="../admissionStudent">
                  <div className=" w-64 bg-[#f8e289] text-center   px-6 py-2.5 text-black font-bold text-md leading-tight uppercase rounded shadow-md hover:bg-gray-300 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out ">
                    {/* <img src="../assets/admission-icon.png" alt="pic" className="h-32 w-32 mx-auto"/> */}
                    <span className="firstlevel font-bold whitespace-no-wrap hover:text-blue-800 ">
                      Admission Student
                    </span>
                  </div>
                </Link>
              </div>
            </li>
            <li className="relative group mr-6 text-white">
              <div className=" mb-5 mt-5">
                <Link to="../addTeacher">
                  <div className=" w-64 bg-[#f8e289] text-center   px-6 py-2.5 text-black font-bold text-md leading-tight uppercase rounded shadow-md hover:bg-gray-300 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out ">
                    {/* <img src="../assets/add-group.png" alt="pic" className="h-32 w-32 mx-auto"/> */}
                    <span className="firstlevel font-bold whitespace-no-wrap hover:text-blue-800 ">

                      Add Teachers
                    </span>
                  </div>
                </Link>
              </div>
            </li>
            <li className="relative group mr-6 text-white">
              <div className=" mb-5 mt-5">
                <Link to="../addingStudent">
                  <div className=" w-64 bg-[#f8e289] text-center   px-6 py-2.5 text-black font-bold text-md leading-tight uppercase rounded shadow-md hover:bg-gray-300 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out ">
                    <span className="firstlevel font-bold whitespace-no-wrap hover:text-blue-800 ">

                      Add Students
                    </span>
                  </div>
                </Link>
              </div>
            </li>

            <li className="relative group mr-6 text-white">
              <div className=" mb-5 mt-5">
                <Link to="../studentResult">
                  <div className=" w-64 bg-[#f8e289] text-center   px-6 py-2.5 text-black font-bold text-md leading-tight uppercase rounded shadow-md hover:bg-gray-300 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out ">
                    <span className="firstlevel font-bold whitespace-no-wrap hover:text-blue-800 ">

                      Results
                    </span>
                  </div>
                </Link>
              </div>
            </li>

            <div className=" mb-5 mt-5">
              <Link to="../schoolleavingcertificate">
                <div className=" w-64 bg-[#f8e289] px-6 py-2.5 text-black font-bold text-sm leading-tight uppercase rounded shadow-md hover:bg-gray-300 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out">
                  <span className="firstlevel font-bold whitespace-no-wrap hover:text-blue-800 ">
                    School Leaving Certificate
                  </span>
                </div>
              </Link>
            </div>
          </ul>
        </motion.div>

        <motion.div
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          viewport={{ once: true }}
          className="h-80 w-full flex justify-center items-center bg-gray-50 shadow-lg rounded-lg"
        >
          <div className="">
            <h1 className="text-lg font-bold">Upload Syllabus</h1>
            <input
              type="file"
              className="py-3 mt-2 ml-4"
              onChange={(e) => {
                setUploadFile(e.target.files[0]);
              }}
            />
            <div className="flex flex-col justify-center mt-2">
              <table>
                <tbody>
                  <tr className="">
                    <td className="text-sm font-medium text-gray-900">
                      <span>book Name</span>
                    </td>
                    <td className="text-sm text-gray-900 font-medium whitespace-nowrap">
                      <input
                        type="text"
                        className="shadow-xl rounded-lg py-2 ml-4 w-full px-2"
                        value={bookName}
                        onChange={(e) => {
                          setBookName(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr className="">
                    <td className="text-sm font-medium text-gray-900">
                      <span>Class</span>
                    </td>
                    <td className="text-sm text-gray-900 font-medium  whitespace-nowrap">
                      <select
                        value={className}
                        onChange={(e) => {
                          setClassName(e.target.value);
                        }}
                        className="shadow-xl py-2 ml-4 mt-4 w-full px-2 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      >
                        <option value="select"> select</option>
                        <option value="10th">10th</option>
                        <option value="11th/12th">11th/12th</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="p-2 space-x-4 mt-2">
                <button
                  className="bg-green-500 hover:bg-green-600 active:bg-green-700 focus:outline-none focus:ring focus:ring-green-300 px-5 py-2 font-semibold text-white rounded-lg shadow-lg"
                  onClick={handleUpload}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          viewport={{ once: true }}
          className="h-80 w-full flex justify-center items-center bg-gray-50 shadow-lg rounded-lg"
        >
          <div
            onClick={() =>
              setOpenNotice(() => {
                setCloseNotice(false);
                setOpenNotice(true);
              })
            }
            className="justify-center items-center hover:cursor-pointer"
          >
            <img
              src="../assets/notice-icon.png"
              alt="pic"
              className="h-32 w-32 mx-auto"
            />
            <span className=" text-lg font-bold">Notice Board</span>
          </div>
        </motion.div>

        <motion.div
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          viewport={{ once: true }}
          className="h-80 w-full flex justify-center items-center bg-gray-50 shadow-lg rounded-lg"
        >
          <div className="m-4">
            <h1 className="text-lg font-bold">Topper's Section</h1>
            <input
              type="file"
              className="py-3 mt-2 ml-4"
              onChange={(e) => {
                setUploadFileToppers(e.target.files[0]);
              }}
            />
            <div className="flex flex-col justify-center mt-2 gap-2">
              <table>
                <tbody>
                  <tr className="">
                    <td className="text-sm font-medium text-gray-900">
                      <span>Student Name</span>
                    </td>
                    <td className="text-sm text-gray-900 font-medium whitespace-nowrap">
                      <input
                        type="text"
                        className="shadow-xl rounded-lg py-2 ml-4 w-56 px-2"
                        value={studentName}
                        onChange={(e) => {
                          setStudentName(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr className="">
                    <td className="text-sm font-medium text-gray-900">
                      <span>Percentage</span>
                    </td>
                    <td className="text-sm text-gray-900 font-medium whitespace-nowrap">
                      <input
                        type="text"
                        className="shadow-xl rounded-lg py-2 mt-4 ml-4 w-56 px-2"
                        value={studentPercentage}
                        onChange={(e) => {
                          setStudentPercentage(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr className="">
                    <td className="text-sm font-medium text-gray-900">
                      <span>Stream</span>
                    </td>
                    <td className="text-sm text-gray-900 font-medium  whitespace-nowrap">
                      <select
                        value={classStream}
                        onChange={(e) => {
                          setClassstream(e.target.value);
                        }}
                        className="shadow-xl py-2 ml-4 mt-4 w-56 px-2 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      >
                        <option value="select"> select</option>
                        <option value="10th">10th</option>
                        <option value="12th Science">12th Science</option>
                        <option value="12th Commerce">12th Commerce</option>
                        <option value="12th Arts">12th Arts</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="p-2 space-x-4 mt-2">
                <button
                  className="bg-green-500 hover:bg-green-600 active:bg-green-700 focus:outline-none focus:ring focus:ring-green-300 px-5 py-2 font-semibold text-white rounded-lg shadow-lg"
                  onClick={handleToppersUpload}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          viewport={{ once: true }}
          className="h-80 w-full flex justify-center items-center bg-gray-50 shadow-lg rounded-lg"
        >
          <div className="m-4">
            <h1 className="text-lg font-bold">Gallery Section</h1>
            <input
              type="file"
              className="py-3 mt-2 ml-4"
              onChange={(e) => {
                setUploadFileGallery(e.target.files[0]);
              }}
            />
            <div className="flex flex-col justify-center mt-2 gap-2">
              <table>
                <tbody>
                  <tr className="">
                    <td className="text-sm font-medium text-gray-900">
                      <span>Category</span>
                    </td>
                    <td className="text-sm text-gray-900 font-medium  whitespace-nowrap">
                      <select
                        value={category}
                        onChange={(e) => {
                          setCategory(e.target.value);
                        }}
                        className="shadow-xl py-2 ml-4 mt-4 w-56 px-2 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      >
                        <option value="select"> select</option>
                        <option value="In House Competition">
                          In House Competition
                        </option>
                        <option value="Ethics Club">Ethics Club</option>
                        <option value="Projects">Projects</option>
                        <option value="Culture Activity">
                          Culture Activity
                        </option>
                        <option value="Activity">Activity</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="p-2 space-x-4 mt-2">
                <button
                  className="bg-green-500 hover:bg-green-600 active:bg-green-700 focus:outline-none focus:ring focus:ring-green-300 px-5 py-2 font-semibold text-white rounded-lg shadow-lg"
                  onClick={handleGalleryUpload}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {openNotice && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
          <div className="fixed z-0 grid grid-rows-3 justify-center inset-0 overflow-y-auto p-20">
            <div className=" bg-white rounded-md row-span-2">
              <div className="w-full  place-self-center rounded-lg  ">
                <div className="flex justify-end">
                  <button
                    className=""
                    onClick={() =>
                      setOpenNotice(() => {
                        setCloseNotice(true);
                        setOpenNotice(false);
                      })
                    }
                  >
                    <img
                      src="../assets/close-button.png"
                      alt="pic"
                      className="h-10 w-10"
                    />
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-2">
                <div className="w-full max-w-sm ml-10">
                  <div className="md:flex md:items-center ">
                    <div className="md:w-1/4">
                      <label className="block text-black font-bold md:text-center mb-1 md:mb-0 pr-4">
                        Title
                      </label>
                    </div>
                    <div className="md:w-3/5">
                      <input
                        value={noticeTitle}
                        onChange={(e) => {
                          setNoticeTitle(e.target.value);
                        }}
                        type="text"
                        placeholder="Title"
                        className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full max-w-sm ml-10">
                  <div className="md:flex md:items-center ">
                    <div className="md:w-1/4">
                      <label className="block text-black font-bold md:text-center mb-1 md:mb-0 pr-4">
                        Date
                      </label>
                    </div>
                    <div className="md:w-1/2">
                      <input
                        value={noticeDate}
                        onChange={(e) => {
                          setNoticeDate(e.target.value);
                        }}
                        type="date"
                        className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        placeholder="Select a date"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-52 w-full pr-10 pl-10 ">
                {/* <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Your Notice</label> */}
                <textarea
                  value={notice}
                  onChange={(e) => {
                    setNotice(e.target.value);
                  }}
                  className="w-full h-40 px-3 mt-3 text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Your message..."
                />
              </div>
              <div className="mx-auto">
                <button
                  className="bg-green-400 p-1 text-2xl text-white font-semibold rounded-lg"
                  onClick={addNotice}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminDashboard;
